<div class="{{isLoading}}"></div>
<div class="snackbar {{show}}">{{message}}</div>
<section class="login-hero">

    <div class="actual-form">

        <h1>Log In</h1>

        <form  class="login-hero">
            <input class="input-text" type="email" placeholder="Email" name="email" [(ngModel)]="params.email">
            <br>
            <input class="input-text" type="password" placeholder="Password" name="password" [(ngModel)]="params.password">
            <br>
            <button (click)="submitLogin()" *ngIf="isLoading!='loading'">Log In</button>
            <button (click)="submitLogin()" color="gray" disabled *ngIf="isLoading=='loading'">Log In</button>
        </form>
        <br>

        <p>Forgot Password? <a href="/forgot">click here</a></p>
        <p>Dont have an account <a href="/signup">Register here</a></p>

    </div>

</section>